import { resolveAssetUrl } from "./backendUrls";
export const DEFAULT_BRANDING = { primaryColor: "#ffffff", secondaryColor: "#000000", accentColor: "#5856e9", fontFamily: "Inter, sans-serif" };
export const normaliseBrandColor = (value, fallback) => /^#(?:[\da-f]{3}|[\da-f]{6}|[\da-f]{8})$/i.test(value || "") ? value : fallback;
export const brandColorChannels = (color) => {
  let hex = color.slice(1);
  if (hex.length === 3) hex = hex.split("").map((digit) => digit + digit).join("");
  return [0, 2, 4].map((offset) => parseInt(hex.slice(offset, offset + 2), 16)).join(" ");
};
export const normaliseBranding = (branding = {}) => {
  branding = branding || {};
  return ({
  ...branding,
  primaryColor: normaliseBrandColor(branding.primaryColor, DEFAULT_BRANDING.primaryColor),
  secondaryColor: normaliseBrandColor(branding.secondaryColor, DEFAULT_BRANDING.secondaryColor),
  accentColor: normaliseBrandColor(branding.accentColor, DEFAULT_BRANDING.accentColor),
  fontFamily: branding.fontFamily?.trim() ? `${branding.fontFamily}, sans-serif` : DEFAULT_BRANDING.fontFamily,
  });
};
export const brandingAssetUrl = resolveAssetUrl;
export const brandingVariables = (settings) => {
  const branding = normaliseBranding(settings);
  const vars = { "--font-family": branding.fontFamily };
  for (const name of ["primary", "secondary", "accent"]) {
    const color = branding[`${name}Color`];
    vars[`--color-${name}`] = color;
    vars[`--color-${name}-rgb`] = brandColorChannels(color);
    vars[`--color-${name}-alpha`] = color.length === 9 ? String(parseInt(color.slice(7), 16) / 255) : "1";
  }
  const luminance = brandColorChannels(branding.accentColor).split(" ").map(Number).map((v) => {
    const channel = v / 255;
    return channel <= 0.04045 ? channel / 12.92 : ((channel + 0.055) / 1.055) ** 2.4;
  });
  const brightness = luminance[0] * 0.2126 + luminance[1] * 0.7152 + luminance[2] * 0.0722;
  vars["--color-on-accent"] = brightness > 0.179 ? "#000000" : "#ffffff";
  const channels = (color) => brandColorChannels(color).split(" ").map(Number);
  const lightness = (rgb) => rgb.map((v) => {
    const c = v / 255;
    return c <= 0.04045 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  }).reduce((sum, c, i) => sum + c * [0.2126, 0.7152, 0.0722][i], 0);
  const background = lightness(channels(branding.primaryColor));
  const target = background > 0.179 ? 0 : 255;
  const accent = channels(branding.accentColor);
  let text = accent;
  for (let step = 0; step <= 100; step++) {
    text = accent.map((c) => Math.round(c + (target - c) * step / 100));
    const foreground = lightness(text);
    if ((Math.max(foreground, background) + 0.05) / (Math.min(foreground, background) + 0.05) >= 4.5) break;
  }
  vars["--color-accent-text-rgb"] = text.join(" ");
  vars["--color-accent-text"] = `rgb(${text.join(" ")})`;
  return vars;
};
